import React from 'react';
import { Skeleton } from 'antd';
import useDefaultChartsContainer from 'hooks/defaultChartsContainer';
import useTwitterPostsCounts from 'hooks/useTwitterPostsCounts';
import { Container } from './styles';
import PostsByNetworkCard from './PostsByNetworkCard';

const PostsByNetwork: React.FC = () => {
  const {
    paramsDatas,
    loading: volumeLoading,
    searchedTerms,
  } = useDefaultChartsContainer('/historical_volume.json', {
    grouping: 'service',
  });
  const {
    counts: twitterCounts,
    loading: twitterLoading,
  } = useTwitterPostsCounts();

  const loading = volumeLoading || twitterLoading;

  return (
    <Container>
      {paramsDatas &&
        paramsDatas.size >= 1 &&
        searchedTerms.map(item => {
          const key = item.obligatory;
          let metrics = paramsDatas.get(key);
          const twitterCount = twitterCounts.get(key);

          if (metrics && twitterCount !== undefined) {
            metrics = metrics.map(metric =>
              metric.label === 'twitter'
                ? { ...metric, value: twitterCount }
                : metric,
            );
          }

          return metrics ? (
            <PostsByNetworkCard title={key} data={metrics} key={key} />
          ) : null;
        })}
      <Skeleton
        loading={loading}
        active
        title={false}
        paragraph={false}
        avatar={{
          shape: 'square',
          style: {
            height: 400,
            width: '100%',
          },
        }}
      />
    </Container>
  );
};

export default PostsByNetwork;
